/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingnicknamesplaceholder2Inputs */

const en_listingnicknamesplaceholder2 = /** @type {(inputs: Listingnicknamesplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Huberwirt, Huber's`)
};

const de_listingnicknamesplaceholder2 = /** @type {(inputs: Listingnicknamesplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Huberwirt, Huber`)
};

/**
* | output |
* | --- |
* | "e.g. Huberwirt, Huber's" |
*
* @param {Listingnicknamesplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingnicknamesplaceholder2 = /** @type {((inputs?: Listingnicknamesplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingnicknamesplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingnicknamesplaceholder2(inputs)
	return de_listingnicknamesplaceholder2(inputs)
});
export { listingnicknamesplaceholder2 as "listingNicknamesPlaceholder" }